import React from 'react';
import HomeIcon from '@material-ui/icons/Home';
import EventIcon from '@material-ui/icons/Event';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import ChatIcon from '@material-ui/icons/Chat';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import DuoIcon from '@material-ui/icons/Duo';
import ExploreIcon from '@material-ui/icons/Explore';
import DateRangeIcon from '@material-ui/icons/DateRange';
import BackupIcon from '@material-ui/icons/Backup';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ListAltIcon from '@material-ui/icons/ListAlt';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import TelegramIcon from '@material-ui/icons/Telegram';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import MapIcon from '@material-ui/icons/Map';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AssessmentIcon from '@material-ui/icons/Assessment';
import VideocamIcon from '@material-ui/icons/Videocam';
import { ReactComponent as GroupReportingIcon } from '../../../assets/icons/GroupReportingIcon.svg';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

export const SidebarData = [
	{
		title: 'Dashboard',
		icon: <AssessmentIcon />,
		link: '/',
		id: 0,
		canBeNull: false,
	},
	{
		title: 'Video Call',
		icon: <VideocamIcon />,
		link: '/videocall',
		id: 1,
		canBeNull: false,
	},
	{
		title: 'Agenda',
		icon: <CalendarTodayIcon />,
		link: '/agenda',
		id: 2,
		canBeNull: false,
	},
	{
		title: 'Deals',
		icon: <BusinessCenterIcon />,
		link: '/deals',
		id: 3,
		canBeNull: false,
	},
	// {
	// 	title: '3D Virtual Hub',
	// 	icon: <HomeWorkIcon />,
	// 	link: '/3dhomes',
	// 	id: 4,
	// 	canBeNull: true,
	// },
	{
		title: 'Site Plan',
		icon: <MapIcon />,
		link: '/siteplan',
		id: 5,
		canBeNull: true,
	},
	// {
	// 	title: 'Marketing',
	// 	icon: <TelegramIcon />,
	// 	link: '/marketing',
	// 	role: ['superadmin', 'admin', 'salesadmin', 'cobroker'],
	// 	canBeNull: true,
	// },
	{
		title: 'Marketing',
		icon: <PermMediaIcon />,
		link: '/fileexplorer',
		id: 6,
		canBeNull: true,
	},
	{
		title: 'Reporting',
		icon: <GroupReportingIcon />,
		link: '/reporting',
		id: 10,
		role: ['superadmin', 'admin'],
		canBeNull: true,
	},
	// {
	// 	title: 'User Management',
	// 	icon: <ManageAccountsIcon />,
	// 	link: '/user-management',
	// 	id: 7,
	// 	canBeNull: true,
	// },
	// {
	// 	title: 'Finances',
	// 	icon: <AttachMoneyIcon />,
	// 	link: '/finance',
	// 	role: ['superadmin', 'admin'],
	// 	canBeNull: true,
	// },
	// {
	// 	title: 'Box Matrix',
	// 	icon: <ListAltIcon />,
	// 	link: '/box-matrix',
	// 	role: ['superadmin', 'admin'],
	// 	canBeNull: true,
	// },
	// {
	// 	title: 'Join Appointment',
	// 	icon: <MeetingRoomIcon />,
	// 	link: '/join-appointment',
	// 	id: 8,
	// 	canBeNull: true,
	// },
	// {
	// 	title: 'Book Appointment',
	// 	icon: <GroupAddIcon />,
	// 	link: '/book-appointment',
	// 	id: 9,
	// 	canBeNull: true,
	// },
];
